module.exports = __webpack_public_path__ + "img/vl-tracking-logo.763cfb16.svg";